<template>
  <div id="app">
    <div class="ambient"></div>
    <div class="container">
      <header class="header">
        <router-link to="/" class="brand">
          <span class="mark" aria-hidden="true">
            <svg viewBox="0 0 32 32" width="22" height="22">
              <path d="M16 2.5 L28 9.2 V22.8 L16 29.5 L4 22.8 V9.2 Z" fill="none" stroke="#d4af37" stroke-width="1.6"/>
              <path d="M16 8 L22 11.5 V18.5 L16 22 L10 18.5 V11.5 Z" fill="#d4af37"/>
            </svg>
          </span>
          <span class="brand-name">{{ $t('appname') }}</span>
        </router-link>
        <button class="changeLan" @click="changeLange()" aria-label="切换语言 / Change language">
          <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.6">
            <circle cx="12" cy="12" r="9"/>
            <path d="M3 12h18M12 3c3 3.5 3 14.5 0 18M12 3c-3 3.5-3 14.5 0 18"/>
          </svg>
        </button>
      </header>
      <router-view/>
    </div>
    <footer class="footerdiv">
      <router-link to="/" class="footer-item nav-item" active-class="active">
        <div class="icon">
          <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.7">
            <path d="M4 11.5 L12 4.5 L20 11.5 V20 H15 V14 H9 V20 H4 Z"/>
          </svg>
        </div>
        <div class="label">{{ $t('app.product') }}</div>
      </router-link>
      <router-link  to="/order"  class="footer-item nav-item" active-class="active">
        <div class="icon">
          <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.7">
            <rect x="4" y="5" width="16" height="14" rx="2"/>
            <path d="M8 9h8M8 13h5"/>
          </svg>
        </div>
        <div class="label">{{ $t('app.order') }}</div>
      </router-link>
      <router-link to="/my" class="footer-item nav-item" active-class="active">
        <div class="icon">
          <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.7">
            <circle cx="12" cy="8" r="3.2"/>
            <path d="M5 19c1.4-3.2 4-4.8 7-4.8S17.6 15.8 19 19"/>
          </svg>
        </div>
        <div class="label">{{ $t('app.my') }}</div>
      </router-link>
    </footer>
  </div>


  <div class="showalletdiv" v-if="showWalletDialog">
    <div id="overlay" class="overlay"></div>
    <div id="dialog" class="showallet">
      <div class="showallet-content">
        <p>{{showWalletMsg}}</p>
      </div>
      <div class="showallet-actions">
        <button class="confirm-button" @click="okclose()">OK</button>
      </div>
    </div>
  </div>


  <div v-if="changeLang" class="showalletdiv">
    <div id="overlay" class="overlay"></div>
    <div id="dialog" class="showallet lang-dialog">
      <div class="dialog-header">
        <span>Language</span>
        <button class="close-button" @click="changeLange()">&times;</button>
      </div>


      <button class="lange" data-lang="cn" @click="tochangeLang('zh')">
        <svg width="20" height="14" style="vertical-align: middle;">
          <rect width="20" height="14" fill="#de2910" />
          <path d="M4,2 L5.2,6.8 L9,2.8 L5.6,5.6 L6.8,9.2 L4,6 L1.2,9.2 L2.4,5.6 L0,2.8 L3.8,6.8 Z" fill="#ffde00" />
        </svg> 中文
      </button>

      <button class="lange" data-lang="en" @click="tochangeLang('en')">
        <svg width="20" height="14" style="vertical-align: middle;">
          <rect width="20" height="14" fill="#012169" />
          <path d="M0 0 L20 14 M20 0 L0 14" stroke="#fff" stroke-width="3"/>
          <path d="M0 0 L20 14 M20 0 L0 14" stroke="#c8102e" stroke-width="1.4"/>
          <path d="M10 0 V14 M0 7 H20" stroke="#fff" stroke-width="5"/>
          <path d="M10 0 V14 M0 7 H20" stroke="#c8102e" stroke-width="2.4"/>
        </svg> English
      </button>
    </div>
  </div>
</template>
<script>
import {mapState} from "vuex";
import {setCookie} from "@/utils/cookie";
export default {
  name: 'App',
  data() {
    return {
      loading: true,
      data: null,
      isconnect:false,
      changeLang:false,
    };
  },
  created() {
    this.listenWallet()
    this.isconnect = this.$store.state.walletConnectModel.getIsConnectedState()
  },
  computed: {
    ...mapState({
      showWalletDialog: state => state.showWalletDialog,
      showWalletMsg:state => state.showWalletMsg
    }),
  },
  methods: {
    tochangeLang(lang_index){
      setCookie("lang_index",lang_index,100)
      this.$router.go(0);
    },
    changeLange(){
      this.changeLang = !this.changeLang;
    },
    okclose(){
      if(this.showWalletDialog){
        this.$store.commit('setShowWalletMsg', "");
      }
    },
    async listenWallet(){
      try {
        await this.$store.dispatch('listenWallet');
      } catch (error) {
        console.error('Failed to listenWallet:', error);
      }
    }
  }
};
</script>
<style>
.ambient {
  position: fixed;
  inset: 0;
  pointer-events: none;
  background:
    linear-gradient(180deg, rgba(212, 175, 55, 0.05), transparent 28%),
    repeating-linear-gradient(90deg, rgba(255,255,255,0.015) 0 1px, transparent 1px 72px);
  z-index: 0;
}

.container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 600px;
  max-width: 100%;
  background: transparent;
  position: relative;
  z-index: 1;
}

header.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 20px;
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  width: 600px;
  max-width: 100%;
  top: 0;
  z-index: 1000;
  background: rgba(6, 8, 13, 0.78);
  border-bottom: 1px solid rgba(212, 175, 55, 0.16);
  backdrop-filter: blur(18px);
}

.brand {
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  color: inherit;
}

.mark {
  display: inline-flex;
  width: 32px;
  height: 32px;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: rgba(212, 175, 55, 0.1);
  border: 1px solid rgba(212, 175, 55, 0.3);
}

.brand-name {
  font-family: "Cormorant Garamond", serif;
  font-size: 1.35rem;
  font-weight: 600;
  letter-spacing: 0.12em;
}

main {
  flex: 1;
  padding: 88px 18px 6.2rem;
}

footer.footerdiv {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  background: rgba(10, 14, 22, 0.92);
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  width: 600px;
  max-width: 100%;
  bottom: 0;
  z-index: 1000;
  border-top: 1px solid rgba(212, 175, 55, 0.16);
  backdrop-filter: blur(18px);
  gap: 0;
}

.footer-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #8d96a8;
  text-decoration: none;
  text-align: center;
  padding: 10px 0 12px;
  background: transparent;
  border-top: 2px solid transparent;
}

.footer-item.active {
  background: transparent;
  color: #f0d78c;
  border-top-color: #d4af37;
}

.footer-item .icon {
  font-size: 1.2rem;
  margin-bottom: 4px;
  display: flex;
}

.footer-item .label {
  font-size: 0.72rem;
  letter-spacing: 0.08em;
}

.nav-item {
  cursor: pointer;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(6, 8, 13, 0.62);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

.loading-spinner {
  border: 3px solid rgba(212, 175, 55, 0.2);
  border-top: 3px solid #d4af37;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.showalletdiv{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.62);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

.showallet {
  background: #141a27;
  padding: 22px;
  border-radius: 18px;
  width: 320px;
  border: 1px solid rgba(212, 175, 55, 0.28);
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.5);
  position: relative;
  z-index: 2000;
}

.showallet-content p {
  margin: 0 0 16px;
  line-height: 1.6;
  color: #f4f1ea;
}

.showallet-actions {
  display: block;
  text-align: center;
}

.confirm-button {
  background: linear-gradient(180deg, #f3d98a 0%, #c9a227 100%);
  color: #1a1404;
  padding: 10px 28px;
  border: none;
  border-radius: 999px;
  font-size: 0.95rem;
  font-weight: 700;
  cursor: pointer;
}

.confirm-button:active {
  filter: brightness(0.95);
}

.changeLan{
  background: rgba(255,255,255,0.04);
  border: 1px solid rgba(212, 175, 55, 0.22);
  color: #f0d78c;
  cursor: pointer;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.lange{
  font-size: 1rem;
  background: rgba(255,255,255,0.04);
  border: 1px solid rgba(255,255,255,0.08);
  color: white;
  cursor: pointer;
  width: 100%;
  padding: 12px;
  border-radius: 12px;
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.lang-dialog .dialog-header span {
  letter-spacing: 0.08em;
}

#app {
  display: flex;
  justify-content: center;
  min-height: 100%;
}

@media (max-width: 600px) {
  .container,
  header.header,
  footer.footerdiv {
    width: 100%;
  }
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.dialog-header span {
  font-size: 1rem;
  font-weight: 600;
}

.close-button {
  background: none;
  border: none;
  color: white;
  font-size: 1.4rem;
  cursor: pointer;
  line-height: 1;
}
</style>
